import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";

import {
  assignTeamsToTournamentBlock,
  autoGenerateFixtures,
  addFixtureResult,
  bulkCreateTournamentPhases,
  bulkLockPhases,
  createCustomFixture,
  createFixture,
  createMatchBreak,
  createTournamentBlock,
  createTournamentPhase,
  deleteBlock,
  deletePhase,
  deleteTeamsFromBlock,
  executeProgressionRules,
  fetchTournamentDashboard,
  generateAllFixtures,
  goLive,
  updateBlock,
  updateFixture,
  updatePhase,
  updateTeamsInBlock,
} from "../slices/tournamentSlice";

export const dashboardRefreshMiddleware = createListenerMiddleware();

dashboardRefreshMiddleware.startListening({
  matcher: isAnyOf(
    addFixtureResult.fulfilled,
    assignTeamsToTournamentBlock.fulfilled,
    autoGenerateFixtures.fulfilled,
    bulkCreateTournamentPhases.fulfilled,
    bulkLockPhases.fulfilled,
    createCustomFixture.fulfilled,
    createFixture.fulfilled,
    createMatchBreak.fulfilled,
    createTournamentBlock.fulfilled,
    createTournamentPhase.fulfilled,
    deleteBlock.fulfilled,
    deletePhase.fulfilled,
    deleteTeamsFromBlock.fulfilled,
    executeProgressionRules.fulfilled,
    generateAllFixtures.fulfilled,
    goLive.fulfilled,
    updateBlock.fulfilled,
    updateFixture.fulfilled,
    updatePhase.fulfilled,
    updateTeamsInBlock.fulfilled,
  ),
  effect: async (_action, { dispatch, getState, cancelActiveListeners }) => {
    cancelActiveListeners();
    const tid = getState().tournament?.dashboard?.tournamentId;
    if (!tid) return;
    dispatch(fetchTournamentDashboard(tid));
  },
});
